// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"e5b28b46","451":"843498cd"}[chunkId] + ".chunk.js";
};